import { render, staticRenderFns } from "./UserElement.vue?vue&type=template&id=e3ff01cc&scoped=true"
import script from "./UserElement.vue?vue&type=script&lang=js"
export * from "./UserElement.vue?vue&type=script&lang=js"
import style0 from "./UserElement.vue?vue&type=style&index=0&id=e3ff01cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ff01cc",
  null
  
)

export default component.exports